<mat-form-field
  appearance="outline"
  [formGroup]="formGroup"
  style="margin-bottom: -1.25em; width: 100%;"
  >
  <mat-label>{{config?.label}}</mat-label>
  <mat-chip-grid #chipList [required]="requerido">
    @if (selecionado) {
      <mat-chip-row>
        {{getValue()}}
        @if (!controle.disabled) {
          <!-- matChipRemove: botão de remover do próprio chip (o mat-icon-button não cabia no chip). -->
          <button
            matChipRemove
            type="button"
            aria-label="Limpar"
            (click)="limpar($event)"
            >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
    @if (carregando && controle.dirty) {
      <mat-progress-spinner
        matSuffix
        diameter="20"
        mode="indeterminate"
        color="accent"
      ></mat-progress-spinner>
    }
    <input
      #searchInput
      type="text"
      [placeholder]="config.placeholder"
      matInput
      [required]="requerido"
      [formControl]="getForm()"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      (keydown)="onBackspace($event)"
      [disabled]="selecionado !== null"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="atualizaControle($event)"
      >
      @for (option of values; track option) {
        <mat-option [value]="option">
          {{option[entityText]}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
